"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.Items = exports.Wrapper = exports.Link = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _polished = require("polished");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Link = _styledComponents.default.span.withConfig({
  displayName: "Breadcrumbsstyle__Link",
  componentId: "wxjk1e-0"
})(["", ""], function (_ref) {
  var to = _ref.to,
    theme = _ref.theme;
  return !to && (0, _styledComponents.css)(["font-weight:", ";"], theme.fontWeight.semiBold);
});
exports.Link = Link;
var Wrapper = _styledComponents.default.nav.withConfig({
  displayName: "Breadcrumbsstyle__Wrapper",
  componentId: "wxjk1e-1"
})(["position:relative;&::after{content:'';background:linear-gradient( to right,rgba(255,255,255,0) 0%,", " 50% );width:50px;height:100%;position:absolute;right:0;top:0;display:block;pointer-events:none;@media (min-width:", "){content:none;}}"], function (_ref2) {
  var overlayColor = _ref2.overlayColor;
  return (0, _polished.rgba)(overlayColor, 1);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm;
});
exports.Wrapper = Wrapper;
var Items = _styledComponents.default.ol.withConfig({
  displayName: "Breadcrumbsstyle__Items",
  componentId: "wxjk1e-2"
})(["white-space:nowrap;overflow-x:auto;", ""], (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-right: 50px;\n  "]))));
exports.Items = Items;
var Item = _styledComponents.default.li.withConfig({
  displayName: "Breadcrumbsstyle__Item",
  componentId: "wxjk1e-3"
})(["display:inline-flex;flex-shrink:0;font-size:", ";color:", ";", ",a{padding:", ";@media (min-width:", "){font-size:", ";}}a{cursor:pointer;color:", ";text-decoration:none;transition:", ";&:hover,&:active{color:", ";}}&::after{content:'';margin:", ";border-right:1px solid ", ";}&:first-child{", "}&:last-child{color:", ";", " &::after{content:normal;", "}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.breadcrumbs.fontSize;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breadcrumbs.linkColor;
}, Link, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.sm, " ").concat(theme.space.xs);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.md;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breadcrumbs.fontSizeDesktop;
}, function (_ref9) {
  var theme = _ref9.theme,
    lightText = _ref9.lightText;
  return lightText ? (0, _polished.rgba)(theme.colors.ui00, 0.8) : theme.breadcrumbs.linkColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.animation.transitionMedium;
}, function (_ref11) {
  var theme = _ref11.theme,
    lightText = _ref11.lightText;
  return lightText ? theme.colors.ui00 : theme.breadcrumbs.linkColorHover;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.xs;
}, function (_ref13) {
  var theme = _ref13.theme;
  return (0, _polished.transparentize)(0.9, theme.breadcrumbs.dividerColor);
}, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin-left: 0;\n    "]))), function (_ref14) {
  var theme = _ref14.theme,
    lightText = _ref14.lightText;
  return lightText ? theme.colors.ui00 : theme.breadcrumbs.currentPageItemColor;
}, (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      padding-right: ", ";\n    "])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.md;
}), (0, _styledComponentsRtl.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        margin-left: ", ";\n      "])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.space.md;
}));
exports.Item = Item;